<script>
  import { onMount } from 'svelte';

  onMount(() => {
    window.addEventListener('DOMContentLoaded', (event) => {
      const debug = document.querySelector('.debug');
      const close = document.querySelector('.close');
      close.addEventListener('click', event => {
        debug.style.display = 'none';
      });

      let useCamera = false;
      const cam = document.querySelector('.cam');
      cam.addEventListener('click', event => {
        useCamera = !useCamera;
        document.querySelector('.content').style.pointerEvents = useCamera ? 'none' : 'all';
        document.querySelector('.map-overlay').style.pointerEvents = useCamera ? 'none' : 'all';
      });
    });
  });

</script>

<div class="debug">
  <ul> </ul>
  <a class="button cam">[cam]</a>
  <a class="button close">[X]</a>
</div>


<style>
  .debug {
    display: none;
    box-sizing: border-box;
    position: fixed;
    z-index:999;
    bottom:0;
    left: 0;
    width: 100%;
    height:20px;
    background-color: rgba(255,225,255,0.85);
    color: #000;
    border-right: 2px solid #ddd;
    border-bottom: 2px solid #ddd;
  }

  @media (max-width: 700px) {
    .debug {
      height: 40px;
    }
  }

  .heading {
    display: inline;
    font-weight: 700;
    text-decoration: underline;
  }

  ul {
    list-style-type: none;
    padding-left: 10px;
    display: flex;
    flex-grow: 1;
    margin: 0;
    justify-content: space-evenly;
  }

  a {
    cursor: pointer;
  }

</style>
